module.exports = __webpack_public_path__ + "img/unavailable_crm.22a43b12.svg";